module.exports = __webpack_public_path__ + "img/temp_calendar.96712e0c.png";